import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal display-block"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal display-block background-modal" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-small setting-modal" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.msgError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.t$('masterManager.popupError.title')), 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlingOk && _ctx.handlingOk(...args)))
              }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(_ctx.msgError), 1 /* TEXT */),
              _createElementVNode("p", null, _toDisplayString(_ctx.msgErrorOption), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn--primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlingOk && _ctx.handlingOk(...args)))
              }, _toDisplayString(_ctx.t$('masterManager.popupError.ok')), 1 /* TEXT */)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}